import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BsgShoe } from '../../api/models';

export type TABLE_TYPE = Table<BsgShoe>;

export const TABLE = 'bsgShoe';
const SCHEMA = 'bsgShoeId, sortId';

class BsgShoeDatabase implements DataRepository<BsgShoe> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<BsgShoe | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BsgShoe, key: Key): Promise<BsgShoe> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: BsgShoe[]): Promise<BsgShoe[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BsgShoe[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const BsgShoeDB = new BsgShoeDatabase(db);
